import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
    Button, Grid, Paper, Stack,
    TableBody, TableCell, styled, tableCellClasses, IconButton, TableRow, Switch
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/system";
import Form from "../common/Form";
import Controls from "../controls/Controls";
import useForm from "../common/useForm";
import UseTable from "../common/UseTable";
import EditIcon from "@mui/icons-material/Edit";
import ApiIcon from "@mui/icons-material/Api";
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { format } from "date-fns";
import AddClient from "./AddClient";
import Popup from "../common/Popup";
import ClientApi from "./ClientApi";
import Notification from "../common/Notification";
import { getAllClients, loadAllClients } from "../../store/clients";
import { useConfirm } from "material-ui-confirm";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        whiteSpace: "nowrap",
    },
}));

const headCells = [
    { id: "id", label: "S. No." },
    { id: "dateTime", label: "Date & Time" },

    {
        id: "clientId",
        label: "ID",
        editable: true,
    },
    {
        id: "clientName",
        label: "Name",
        editable: true,
    },
    {
        id: "contactName",
        label: "Key Contact",
        editable: true,
    },
    {
        id: "",
        label: "Applications",
        sortable: false,
    },
    {
        id: "",
        label: "API",
        sortable: false,
    },
    {
        id: "",
        label: "Action",
        sortable: false,
    },
    {
        id: "",
        label: "Status",
        sortable: false,
    }

];

export default function ManageClients() {
    const [open, setOpen] = useState(false);
    const [validateOnChange, setValidateOnChange] = useState(true);
    const [addClientPopup, setAddClientPopup] = useState(false);
    const [clientApiPopup, setClientApiPopup] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedClient1, setSelectedClient1] = useState(null);
    const [pageSize, setPageSize] = useState(5);
    const [pageIndex, setPageIndex] = useState(1);

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });

    const confirm = useConfirm();
    const dispatch = useDispatch();

    const allClientsSelector = useSelector(getAllClients);

    const navigate = useNavigate();

    useEffect(() => {
        dispatch(loadAllClients(pageSize, pageIndex));
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const {
        TblContainer,
        TblHeader,
        TblPagination,
        tblDataAfterPaginationAndSorting,
    } = UseTable(allClientsSelector, headCells, filterFn);

    const handleAddClient = (item) => {
        if (item === "save") dispatch(loadAllClients(pageSize, pageIndex));
        else setSelectedClient(item);
        setAddClientPopup(!addClientPopup);
    };

    const handleClientApi = (item) => {
        setSelectedClient1(item);
        setClientApiPopup(!clientApiPopup);
    };

    const handleClientApp = (item) => {
        navigate(`/clientApp`, {
            state: item
        });
    }

    const handleTogglePopup = () => {
        setAddClientPopup(!addClientPopup);
    }

    const handleSwitchChange = (item) => {
        setNotify({                   // ye useeffect me jayega 
            isOpen: true,
            message: `${item?.status === false ? "Customer Activated Successfully" : "Customer Deactivated Successfully"}`,
            type: "success",
        });
        // setAllUsers((prevUsers) =>    // iski jagah dispatch api ayegi
        //     prevUsers.map((user) =>
        //         user.id === item.id ? { ...user, status: !user.status } : user
        //     )
        // );
    };

    return (
        <>
            <Box display="flex" alignItems="right" justifyContent="right" mb={2}>
                <Controls.Button
                    onClick={handleTogglePopup}
                    text="Add New"
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    sx={{

                        color: 'black',
                        border: "1px solid black",
                        '&:hover': {
                            backgroundColor: 'black',
                            color: 'white',

                        }
                    }}
                >
                </Controls.Button>
            </Box>
            <Paper sx={{ overflow: "auto" }}>
                <TblContainer>
                    <TblHeader />
                    <TableBody>
                        {tblDataAfterPaginationAndSorting().map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.id}</TableCell>
                                <StyledTableCell>
                                    {format(new Date(item.addedDateTime), "MM/dd/yyyy, h:mma")}
                                </StyledTableCell>
                                <StyledTableCell>{item.clientId}</StyledTableCell>
                                <StyledTableCell>{item.name}</StyledTableCell>
                                <StyledTableCell>{item.contactName}</StyledTableCell>
                                <TableCell>
                                    <IconButton
                                        color="primary"
                                        component="span"
                                        size="small"
                                        title="Manage APP"
                                        onClick={() => handleClientApp(item)}
                                    >
                                        <AutoAwesomeMotionIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        color="primary"
                                        component="span"
                                        size="small"
                                        title="Manage API"
                                        onClick={() => handleClientApi(item)}
                                    >
                                        <ApiIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        color="primary"
                                        component="span"
                                        size="small"
                                        title="Edit Client"
                                        onClick={() => handleAddClient(item)}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <Switch
                                        checked={item.status}
                                        onChange={() => handleSwitchChange(item)}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#12d412',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#12d412',
                                            },
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                title={selectedClient ? "Edit Customer" : "Add Customer"}
                openPopup={addClientPopup}
                setOpenPopup={setAddClientPopup}
                handleOpenPopup={handleAddClient}
                size="lg"
            >
                <AddClient
                    setNotify={setNotify}
                    setOpenPopup={setAddClientPopup}
                    selectedClient={selectedClient}
                    handleAddClient={handleAddClient}
                />
            </Popup>
            <Popup
                title="API"
                openPopup={clientApiPopup}
                setOpenPopup={setClientApiPopup}
                handleOpenPopup={handleClientApi}
                size="lg"
            >
                <ClientApi
                    setNotify={setNotify}
                    setOpenPopup={setClientApiPopup}
                    selectedClient={selectedClient1}
                    handleClientApi={handleClientApi}
                />
            </Popup>
            <Notification notify={notify} setNotify={setNotify} />
        </>
    );
}
